import { type ReactNode } from "react";
import { type IngredientLoadState } from "src/api/client-api/ingredients/useGetOneIngredient";
import { EntityForbiddenForCampaignPage } from "src/components/PageState/EntityForbiddenForCampaignPage";
import { Loading } from "src/components/utils/Loading";
import { IngredientLoadStateError } from "./IngredientLoadStateError";

type IngredientLoadStateBoundaryProps = {
    children: ReactNode;
    state: IngredientLoadState;
    onRetry: () => void | Promise<unknown>;
};

export const IngredientLoadStateBoundary = ({ children, state, onRetry }: IngredientLoadStateBoundaryProps) => {
    if (state.status === "success-value") {
        return (
            <>
                {state.refreshError !== undefined && (
                    <IngredientLoadStateError state={{ status: state.refreshError }} onRetry={onRetry} />
                )}
                {children}
            </>
        );
    }

    if (state.status === "loading") {
        return <Loading />;
    }

    if (state.status === "forbidden") {
        return <EntityForbiddenForCampaignPage />;
    }

    return <IngredientLoadStateError state={state} onRetry={onRetry} />;
};
